import { Box, Card, CardContent, CardHeader, Button, Divider, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import React from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import api from '../../api/client'
import { beginImpersonation } from '../../api/impersonation'
import { gregorianToJalali, thousandsSeparate, toFarsiDigits } from '../../assets/utils'
import { exportExcel } from '../../assets/excelUtils'
import { logoSrc } from '../../api/logoSrc'
import { paymentListState } from '../../pages/admin/atoms'
import { userInfoState } from '../../recoil/atoms'

const useStyles = makeStyles(theme => ({
    root: {
        background: '#f1f1f1',
        flexGrow: 1,
        marginBottom: theme.spacing(6)
    },
}))

// تاریخ + ساعت شمسی از رشتهٔ ISO (بدون جابه‌جایی منطقهٔ زمانی)
const fmtDateTime = (v) => {
    if (!v) return '-'
    const s = String(v)
    const datePart = s.slice(0, 10)
    const timePart = s.length >= 16 ? s.slice(11, 16) : ''
    const j = gregorianToJalali(datePart)
    return toFarsiDigits(timePart ? `${j} ${timePart}` : j)
}

const Payments = () => {
    const classes = useStyles()
    const payments = useRecoilValue(paymentListState)
    const setUserInfo = useSetRecoilState(userInfoState)
    const userInfo = useRecoilValue(userInfoState)

    // ورود ادمین با نقش کاربر پرداخت‌کننده — همانند جدول کاربران
    const loginHandler = (id) => {
        beginImpersonation(userInfo)
        api.post('users/login/' + id + '?by=user').then((result) => {
            if (result.status === 200) {
                setUserInfo(result.data.user)
                localStorage.setItem('access', result.data.tokens.access)
                // refresh هم باید توکنِ همین کاربر شود، وگرنه رفرشِ بعدی نشست را به ادمین برمی‌گرداند
                if (result.data.tokens.refresh) {
                    localStorage.setItem('refresh', result.data.tokens.refresh)
                }
                api.defaults.headers.common['Authorization'] = 'Bearer ' + result.data.tokens.access
            }
        })
    }
    return (
        <Card elevation={5} className={classes.root}>
            <CardHeader
                title='پرداخت ها'
                action={
                    payments.length > 0 && (
                        <Box style={{ margin: '8px 16px 0 0' }}>
                            <Button
                                variant='contained'
                                color='secondary'
                                onClick={() => exportExcel({
                                    filename: 'payments.xlsx',
                                    title: 'گزارش پرداخت‌ها',
                                    headers: ['ردیف', 'پرداخت کننده', 'تاریخ', 'مبلغ (ریال)', 'شماره پیگیری'],
                                    rows: payments.map((row, index) => [
                                        index + 1,
                                        row.payer,
                                        row.date ? fmtDateTime(row.date) : '',
                                        row.amount,
                                        row.reference_number || '',
                                    ]),
                                })}
                            >
                                دانلود اکسل
                            </Button>
                        </Box>
                    )
                }
            />
            <Divider />
            <CardContent>
                <TableContainer elevation={5} component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align='center'><strong>لوگو</strong></TableCell>
                                <TableCell padding='checkbox' align='center'><strong>ردیف</strong></TableCell>
                                <TableCell align='right' style={{ textAlign: 'right' }}><strong>پرداخت کننده</strong></TableCell>
                                <TableCell align='center'><strong>تاریخ و ساعت</strong></TableCell>
                                <TableCell align='center'><strong>مبلغ</strong></TableCell>
                                <TableCell align='center'><strong>شماره پیگیری</strong></TableCell>
                                <TableCell align='center'><strong>عملیات</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {payments.map((row, index) => (
                                <TableRow key={`${row.reference_number}-${index}`}>
                                    <TableCell align='center'>
                                        {row.user_id ? (
                                            <img
                                                src={logoSrc(`users/logo/${row.user_id}/`)}
                                                alt=""
                                                style={{ width: 34, height: 34, borderRadius: '50%', objectFit: 'cover', border: '1.5px solid #e3e6f2' }}
                                                onError={(e) => { e.target.style.display = 'none'; e.target.parentNode.textContent = '—' }}
                                            />
                                        ) : (
                                            <span style={{ color: '#bbb' }}>—</span>
                                        )}
                                    </TableCell>
                                    <TableCell padding='checkbox' align='center'><strong>{toFarsiDigits(index + 1)}</strong></TableCell>
                                    <TableCell align='right' style={{ textAlign: 'right' }}>{toFarsiDigits(row.payer)}</TableCell>
                                    <TableCell align='center'>{fmtDateTime(row.date)}</TableCell>
                                    <TableCell align='center'>{toFarsiDigits(thousandsSeparate(row.amount))} ریال</TableCell>
                                    <TableCell align='center'>{toFarsiDigits(row.reference_number)}</TableCell>
                                    <TableCell align='center'>
                                        <Button
                                            variant='contained'
                                            size='small'
                                            startIcon={<ExitToAppIcon style={{ fontSize: 16 }} />}
                                            style={{ backgroundColor: '#1a237e', color: '#fff', fontWeight: 'bold' }}
                                            onClick={() => row.user_id && loginHandler(row.user_id)}
                                        >
                                            ورود
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {payments.length > 0 && (
                                <TableRow>
                                    <TableCell colSpan={9} align="center" style={{
                                        background: '#f5f6fb',
                                        color: '#7b84b8',
                                        fontWeight: 700,
                                        fontSize: 13,
                                        padding: 10,
                                        borderTop: '2px dashed #d5daf3',
                                    }}>
                                        ✓ پایان لیست — {toFarsiDigits(payments.length)} مورد
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    )
}

export default Payments